/*
Documentation

load all styles, assets, here
App is wrapped in a store provider

*/

import React from "react";

import "react-perfect-scrollbar/dist/css/styles.css";
import "assets/argon/vendor/fullcalendar/dist/fullcalendar.min.css";
import "assets/argon/vendor/sweetalert2/dist/sweetalert2.min.css";
import 'react-quill/dist/quill.snow.css';
import 'react-toastify/dist/ReactToastify.css';
import 'react-phone-input-2/lib/high-res.css'
import "react-datepicker/dist/react-datepicker.css";
import 'reactflow/dist/style.css';

import "assets/scss/index.scss";

import App from './App'

import { Provider } from 'react-redux';
import { createRoot } from 'react-dom/client';
import store from 'store';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
    <Provider store={store}>
        <App />
    </Provider>,
);

